import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters, mapActions } from 'vuex';
import slug from 'slugify';
export default {
  data: function data() {
    return {
      baseTcVars: {
        env_country: '',
        env_language: '',
        env_template: this.$store.state.category.tpl,
        user_email: '',
        user_id: '',
        user_category: '',
        user_firstvisit_date: '',
        user_logged: false,
        page_cat1: '',
        page_cat2: '',
        page_cat3: '',
        page_number: 1,
        page_url: this.$route.path,
        list_products: [],
        ga_activated: 1,
        is_search_redirection: false,
        redirection_keyword: false,
        mea_category: false,
        earlybirds: '',
        earlybirds_widgets: '',
        user_authentification: '',
        search_keywords: '',
        search_results_number: '',
        is_store: '',
        store_id: '',
        store_vendor_id: '',
        store_name: ''
      }
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    tpl: 'category/tpl',
    seller: 'seller/me',
    locale: 'i18n/locale',
    products: 'category/products',
    description: 'category/description',
    tcVariables: 'analytics/tcVariables'
  })),
  mounted: function mounted() {
    this.sendTcVars(this.baseTcVars);
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    sendTcVars: 'analytics/sendTcVars',
    updateTcVars: 'analytics/updateTcVars',
    updateTcListProducts: 'analytics/updateTcListProducts'
  })), {}, {
    setTcVars: function setTcVars() {
      var _this$description, _this$description2, _this$description2$co, _this$description2$co2, _this$locale$market, _this$locale, _this$locale$language, _this$locale2, _this$description$bre, _this$description3, _this$description3$br, _this$description$bre2, _this$description4, _this$description4$br, _this$description$bre3, _this$description5, _this$description5$br, _Object$keys$includes, _this$$route$query$s, _this$$route, _this$$route$query, _this$description6, _this$description6$ea, _this$description9;

      var isSearchKeyword = this.tpl === 'listproduct_keyword' && Object.keys(this.description).includes('query');
      var isMeaCategory = ((_this$description = this.description) === null || _this$description === void 0 ? void 0 : _this$description.commercial) && ((_this$description2 = this.description) === null || _this$description2 === void 0 ? void 0 : (_this$description2$co = _this$description2.commercial) === null || _this$description2$co === void 0 ? void 0 : (_this$description2$co2 = _this$description2$co.mea_banner) === null || _this$description2$co2 === void 0 ? void 0 : _this$description2$co2.url);
      this.updateTcVars({
        user_logged: !!this.user,
        env_country: (_this$locale$market = (_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.market) !== null && _this$locale$market !== void 0 ? _this$locale$market : '',
        env_language: (_this$locale$language = (_this$locale2 = this.locale) === null || _this$locale2 === void 0 ? void 0 : _this$locale2.language) !== null && _this$locale$language !== void 0 ? _this$locale$language : '',
        page_cat1: (_this$description$bre = (_this$description3 = this.description) === null || _this$description3 === void 0 ? void 0 : (_this$description3$br = _this$description3.breadcrumb[1]) === null || _this$description3$br === void 0 ? void 0 : _this$description3$br.title) !== null && _this$description$bre !== void 0 ? _this$description$bre : '',
        page_cat2: (_this$description$bre2 = (_this$description4 = this.description) === null || _this$description4 === void 0 ? void 0 : (_this$description4$br = _this$description4.breadcrumb[2]) === null || _this$description4$br === void 0 ? void 0 : _this$description4$br.title) !== null && _this$description$bre2 !== void 0 ? _this$description$bre2 : '',
        page_cat3: (_this$description$bre3 = (_this$description5 = this.description) === null || _this$description5 === void 0 ? void 0 : (_this$description5$br = _this$description5.breadcrumb[3]) === null || _this$description5$br === void 0 ? void 0 : _this$description5$br.title) !== null && _this$description$bre3 !== void 0 ? _this$description$bre3 : '',
        ga_activated: process.client && !window.ga ? 0 : '',
        is_search_redirection: (_Object$keys$includes = Object.keys(this.$route.query).includes('s')) !== null && _Object$keys$includes !== void 0 ? _Object$keys$includes : '',
        redirection_keyword: (_this$$route$query$s = (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$query = _this$$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.s) !== null && _this$$route$query$s !== void 0 ? _this$$route$query$s : '',
        mea_category: isMeaCategory
      });

      if (process.client && this.user) {
        var _this$user$id, _this$user, _window$localStorage$, _this$$cookies$get, _ref, _this$$cookies$get2, _this$user2, _window$localStorage$2;

        this.updateTcVars({
          user_id: (_this$user$id = (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.id) !== null && _this$user$id !== void 0 ? _this$user$id : '',
          user_email: (_window$localStorage$ = window.localStorage.getItem('MDM_MAIL')) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : '',
          user_firstvisit_date: (_this$$cookies$get = this.$cookies.get('MDM[date_first_visit]')) !== null && _this$$cookies$get !== void 0 ? _this$$cookies$get : '',
          user_category: (_ref = (_this$$cookies$get2 = this.$cookies.get('MDM[statut]')) !== null && _this$$cookies$get2 !== void 0 ? _this$$cookies$get2 : (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.type) !== null && _ref !== void 0 ? _ref : '',
          user_authentification: (_window$localStorage$2 = window.localStorage.getItem('MDM_USER_AUTHENTIFICATION')) !== null && _window$localStorage$2 !== void 0 ? _window$localStorage$2 : ''
        });
      }

      var widgetId = (_this$description6 = this.description) === null || _this$description6 === void 0 ? void 0 : (_this$description6$ea = _this$description6.earlybirdsWidgets) === null || _this$description6$ea === void 0 ? void 0 : _this$description6$ea.widgetId;

      if (process.client && widgetId) {
        var _JSON$parse;

        var earlybirdsWidgets = (_JSON$parse = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS'))) !== null && _JSON$parse !== void 0 ? _JSON$parse : {};
        var updatedEarlybirdsWidgets = Object.assign(earlybirdsWidgets, _defineProperty({}, widgetId, this.description.earlybirdsWidgets));
        localStorage.setItem('EARLYBIRDS_WIDGETS', JSON.stringify(updatedEarlybirdsWidgets));
        this.updateTcVars({
          earlybirds: widgetId,
          widgetId: updatedEarlybirdsWidgets
        });
      }

      if (isSearchKeyword) {
        var _slug, _this$description$que, _this$description7, _this$description8;

        this.updateTcVars({
          search_keywords: (_slug = slug((_this$description$que = this.description.query) !== null && _this$description$que !== void 0 ? _this$description$que : '')) !== null && _slug !== void 0 ? _slug : '',
          search_results_number: !((_this$description7 = this.description) !== null && _this$description7 !== void 0 && _this$description7.total) ? 0 : "".concat((_this$description8 = this.description) === null || _this$description8 === void 0 ? void 0 : _this$description8.total)
        });
      }

      if (this.seller) {
        this.updateTcVars({
          is_store: !!this.seller,
          store_id: this.seller.shopId,
          store_vendor_id: this.seller.uid,
          store_name: this.seller.username
        });
      }

      if ((_this$description9 = this.description) !== null && _this$description9 !== void 0 && _this$description9.suggest_query) {
        this.updateTcVars({
          search_results_number: "sug:".concat(this.description.total)
        });
      }

      if (this.products) this.updateTcListProducts(this.products);
      this.sendTcVars();
    }
  })
};